import { useState } from 'react';
import { showToast } from '@/components/Layout';
import { Button } from '@/components/UI';

interface CopySummaryButtonProps {
    /** Builds the text at click time, so it always reflects the slice on screen. */
    buildText: () => string;
    label?: string;
}

/** Copies a plain-text summary of what is on screen, for notes, chats, or an AI agent. */
const CopySummaryButton = ({ buildText, label = 'Copy summary' }: CopySummaryButtonProps) => {
    const [isCopying, setIsCopying] = useState(false);

    const copy = async () => {
        if (!navigator.clipboard) {
            showToast('Clipboard is unavailable in this browser', 'error');
            return;
        }

        setIsCopying(true);

        try {
            await navigator.clipboard.writeText(buildText());
            showToast('Summary copied as Markdown', 'success');
        } catch (error) {
            showToast(error instanceof Error ? `Could not copy the summary: ${error.message}` : 'Could not copy the summary', 'error');
        } finally {
            setIsCopying(false);
        }
    };

    return (
        <Button
            isLoading={isCopying}
            size="sm"
            title="Copy this table, the run facts, and a link as Markdown"
            variant="outline-dark"
            onClick={() => void copy()}
        >
            {label}
        </Button>
    );
};

export default CopySummaryButton;
